import { ActionTree } from 'vuex';
import { AppState } from './types';
import { RootState } from '@/store/types';
import {
  SET_IS_SHOW_USER_SETTINGS,
  SET_SERVER_APP_SETTINGS,
  SET_IS_SHOW_CHANGE_PASSWORD,
  SET_IS_SHOW_SIGN_OUT_DIALOG,
  SET_IS_SHOW_CREDENTIALS,
} from './mutationTypes';
import { ServerAppSettings } from '@/types';
import { config } from '@/config';

export const actions: ActionTree<AppState, RootState> = {
  setIsShowUserSettings({ commit }, value: boolean) {
    commit(SET_IS_SHOW_USER_SETTINGS, value);
  },

  setIsShowChangePassword({ commit }, value: boolean) {
    commit(SET_IS_SHOW_CHANGE_PASSWORD, value);
  },

  setIsShowSignOutDialog({ commit }, value: boolean) {
    commit(SET_IS_SHOW_SIGN_OUT_DIALOG, value);
  },

  toggleCredentials({ commit }, value: boolean) {
    commit(SET_IS_SHOW_CREDENTIALS, value);
  },

  socket_setAppSettings({ commit }, settings: ServerAppSettings) {
    commit(SET_SERVER_APP_SETTINGS, settings);
    if (settings.testMode !== undefined) {
      config.testMode = settings.testMode;
    }
    if (settings.showSignerPrompt !== undefined) {
      config.showSignerPrompt = settings.showSignerPrompt;
    }
    if (settings.showGloss !== undefined) {
      config.showGloss = settings.showGloss;
    }
  },
};
